import script from "./StrategyPayeeConfig.vue?vue&type=script&lang=ts&setup=true"
export * from "./StrategyPayeeConfig.vue?vue&type=script&lang=ts&setup=true"

import "./StrategyPayeeConfig.vue?vue&type=style&index=0&id=70c71e90&lang=scss&scoped=true"

import exportComponent from "/Users/breeze/data/code/src/gitlab.goiot.net/chargingc/cms/web2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70c71e90"]])

export default __exports__